import React, {useContext} from 'react';
import {
  InlineDatumReactComponent,
  InlineDatumReactComponentProps,
} from '../types';
import {InlineDataContext} from '../InlineDataProvider';

const UnknownInlineDatum = ({
  datum_type: datumType,
  component,
  name,
}: InlineDatumReactComponent) => {
  if (component) {
    return (
      <div data-testid="unknown-inline-data-component">
        No component found for {name} {datumType} {component}
      </div>
    );
  }

  return (
    <div data-testid="unknown-inline-data">
      Unknown inline datum {name} {datumType}
    </div>
  );
};

export const ReactComponentDatum = (props: InlineDatumReactComponentProps) => {
  const {components} = useContext(InlineDataContext);

  const {datum, onDone} = props;
  const {component, datum_type: datumType} = datum;

  if (!component || !components[component]) {
    onDone({
      type: 'error',
      message: `No component found for ${datumType} ${component}`,
    });
    return <UnknownInlineDatum {...datum} />;
  }

  const Component = components[component];

  return <Component {...props} />;
};
